/* global naja, $, intervalFunction */
class ModalExtension {

    initialize(naja) {
        naja.addEventListener('complete', this.openModal.bind(this));
        naja.addEventListener('init', (e) => {
            this.dataOpenModal();
        });
    }

    dataOpenModal() {
        const elements = document.querySelectorAll('[data-open-modal]');
        for (let i = 0; i < elements.length; i++) {
            elements[i].addEventListener('click', (e) => {
                naja.makeRequest('POST', e.target.dataset.openModal, undefined, {
                    history: false
                });
            })
        }
    }

    openModal(event) {
        let payload = event.detail.payload;

        /*if (
            payload === null ||
            !payload.hasOwnProperty('modalId')
        ) {
            return;

        }*/
        if (_.isUndefined(payload)) {
            return;

        }

        let
            modalId = payload.modalId,
            showModal = payload.showModal,
            modalSize = payload.modalSize;

        if (
            showModal === undefined ||
            showModal === false
        ) {
            return;

        }

        if (modalSize !== null) {
            const selector = '#' + modalId + ' #modal-size';
            let modalSizeEl = document.querySelectorAll(selector);
            if (modalSizeEl[0]) {
                modalSizeEl[0].classList.add(modalSize);
            }

        }

        //document.getElementById('slim-shop-modal-backdrop').classList.remove('hidden');
        //document.getElementById('slim-shop-modal-backdrop').classList.add('show');
        const modal = new bootstrap.Modal(document.getElementById(modalId));

        modal.show();

        //$("#" + modalId).modal('show');

        //document.body.classList.add('slim-shop-modal-open');
        //document.getElementById("ajax-modal").classList.add('open');
    }
}

class LazyLoadExtension {

    initialize(naja)
    {
        naja.addEventListener('init', _ => FN.lazyLoad());
        naja.snippetHandler.addEventListener('afterUpdate', _ => FN.lazyLoad());
    }
}

class SpinnerExtension {

    /**
     * @param naja
     */
    initialize(naja)
    {
        naja.addEventListener('start', this.loadSpinner.bind(this));
        naja.addEventListener('success', this.destroySpinner.bind(this));
    }

    /**
     * Spuštení spinneru
     * @param event
     */
    loadSpinner(event) {
        const hasSpinner = event.detail.options.spinner;
        if (hasSpinner) {
            document.getElementById('spinner-wrapp').classList.remove('hide');

        }
    }

    /**
     * zrušení spinneru
     * @param event
     */
    destroySpinner(event) {
        const hasSpinner = event.detail.options.spinner;
        if (hasSpinner) {
            document.getElementById('spinner-wrapp').classList.add('hide');

        }
    }
}

class NotifyExtensions {

    /**
     * @param naja
     */
    initialize(naja) {
        naja.addEventListener('success', this.showNotify.bind(this));
    }

    /**
     * Zobrazení notify
     * @param event
     */
    showNotify(event) {
        const noty = event.detail.payload.noty;
        if (noty) {
            new Notify({
                status: noty.type,
                //title: 'Notify Title',
                text: noty.message,
                effect: 'slide',
                speed: 300,
                customClass: null,
                customIcon: null,
                showIcon: true,
                showCloseButton: true,
                autoclose: true,
                autotimeout: parseInt(noty.time),
                gap: 90,
                distance: 20,
                type: 3,
                position: 'right top'
            })

        }
    }

}

naja.registerExtension(new ModalExtension());
naja.registerExtension(new SpinnerExtension());
naja.registerExtension(new NotifyExtensions());
naja.registerExtension(new LazyLoadExtension());

document.addEventListener("DOMContentLoaded", () => {
    // naja init
    naja.initialize({
        forceRedirect: true,
        spinner: true,
        history: false
    });

    Nette.toggle = function(selector, visible, srcElement, event) { // eslint-disable-line no-unused-vars

        if (/^\w[\w.:-]*$/.test(selector)) { // id
            selector = '#' + selector;

        }

        // clear toggle inputs
        const clearInputs = '.' + srcElement.dataset.clearInputs;
        if (!_.isUndefined(clearInputs)) {
            const inputs = document.querySelectorAll(clearInputs)
            inputs.forEach(((input, key) => {
                input.value = '';
            }))

        }

        const elems = document.querySelectorAll(selector);
        for (let i = 0; i < elems.length; i++) {
            elems[i].hidden = !visible;

        }
    };
});


